export default "__VITE_ASSET__48501c6d__"